import { z } from 'zod';
import { AcademicYear, UnixTimestamp } from '../types/branded';
import { EnrollmentPeriodStatus, IntegrationStatusState } from '../types/enums';

export const IntegrationStatusSchema = z.object({
  state: IntegrationStatusState,
  lastSyncAt: UnixTimestamp.nullish(),
  error: z.string().nullish(),
  sourceSystem: z.string().nullish(),
  sourceVersion: z.string().nullish(),
}).passthrough();
export type IntegrationStatus = z.infer<typeof IntegrationStatusSchema>;

export const EnrollmentPeriodSchema = z.object({
  academicYear: AcademicYear,
  startDate: UnixTimestamp,
  endDate: UnixTimestamp,
  status: EnrollmentPeriodStatus,
}).passthrough();
export type EnrollmentPeriod = z.infer<typeof EnrollmentPeriodSchema>;
